import React from "react";
import WidgetFrame from "./WidgetFrame";

// Renders one screen: every widget absolutely positioned on the computed stage.
const ScreenRenderer = ({ screen, stage, agency, board }) => {
  if (!screen) return null;
  return (
    <div
      className="sb-screen"
      style={{
        position: "absolute",
        left: stage.left,
        top: stage.top,
        width: stage.width,
        height: stage.height,
        background: screen.background || undefined,
      }}
    >
      {(screen.widgets || []).map((widget) => (
        <WidgetFrame
          key={widget.id}
          widget={widget}
          stage={stage}
          agency={agency}
          board={board}
        />
      ))}
    </div>
  );
};

export default ScreenRenderer;
